import { render, staticRenderFns } from "./VMarketpalceVehiclesManagerTable.vue?vue&type=template&id=ef8e436a"
import script from "./VMarketpalceVehiclesManagerTable.vue?vue&type=script&lang=js"
export * from "./VMarketpalceVehiclesManagerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports